import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { CheckboxCustomEvent, IonCheckbox } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-checkbox-group-chips',
    imports: [CommonModule, IonCheckbox],
    templateUrl: './checkbox-group-chips.component.html',
    styleUrl: './checkbox-group-chips.component.css'
})
export class CheckboxGroupChipsComponent {
    /* eslint-disable */
    @Input() options: Array<{
        label: string;
        value?: string;
        checked: boolean;
    }> = [];

    @Input() chipsPerRow: 'wrap' | string | number | undefined = undefined;
    @Input() chipStyle: 'fill' | 'outline' = 'fill';

    @Output() onChange = new EventEmitter();

    onCheckboxChange(event: CheckboxCustomEvent) {
        const value = event.detail.value;
        const checked = event.detail.checked;

        const currentOption = this.options.find(option => option.value === value);
        if (currentOption) {
            currentOption.checked = checked;
        }

        this.onChange.emit({ value, checked });
    }
}
